/* eslint-disable react/no-danger */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Detector from '../../partials/Detector';

import { replaceIcons } from '../../../lib/utils';

import styles from '../../../../styles/blocks/employee/image-text.module.scss';

const propTypes = {
    body: PropTypes.string,
    isContainer: PropTypes.bool,
    color: PropTypes.string,
    withLine: PropTypes.bool,
    className: PropTypes.string,
    textClassName: PropTypes.string,
};

const defaultProps = {
    body: null,
    isContainer: false,
    color: null,
    withLine: false,
    className: null,
    textClassName: null,
};

const ImageText = ({ body, isContainer, color, withLine, className, textClassName }) => {
    const [visible, setVisible] = useState(false);
    const onEnter = useCallback(() => {
        setVisible(true);
    }, [setVisible]);

    const finalBody = replaceIcons(body);

    return (
        <Detector onEnter={onEnter}>
            <div
                className={classNames([
                    styles.container,
                    {
                        [styles.visible]: visible,
                        [className]: className !== null,
                    },
                ])}
            >
                <div
                    className={classNames([
                        styles.inner,
                        {
                            [styles.isContainer]: isContainer,
                            [styles.withLine]: withLine,
                            [textClassName]: textClassName,
                        },
                    ])}
                    style={{ color: `${color}`, borderColor: `${color}` }}
                    dangerouslySetInnerHTML={{ __html: finalBody }}
                />
            </div>
        </Detector>
    );
};

ImageText.propTypes = propTypes;
ImageText.defaultProps = defaultProps;

export default ImageText;
